import { createSelector } from 'reselect';

import { State } from './types';

function getHelpTopics(state: State) {
	return state.topics;
}
export const selectHelpTopics = createSelector([getHelpTopics], topics => topics);
